import { useNavigationLinks } from "../hook/useNavigationLinks";
import { NavigationLinkDesktop } from "./NavigationLinkDesktop";

export const NavigationDesktop = () => {
    const links = useNavigationLinks();

    return (
        <>
            {links.map((link) => (
                <NavigationLinkDesktop key={link.title} link={link} />
            ))}
        </>
    );
};
